import api from '../api';

const syscheckApiService = {
  triggerSyscheckScan: async (agentId) => {
    const response = await api.put('/syscheck/trigger-syscheck', { agent_id: agentId });
    return response.data;
  },

  getSyscheckResult: async (agentId) => {
    const response = await api.get(`/syscheck/result/${agentId}`);
    return response.data;
  },

  getLastScan: async (agentId) => {
    const response = await api.get(`/syscheck/last_scan/${agentId}`);
    return response.data;
  },
};

export default syscheckApiService;
